"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Language = exports.Direction = void 0;
Object.defineProperty(exports, "PlatformId", {
  enumerable: true,
  get: function get() {
    return _icfPlatformid.PlatformId;
  }
});
exports.themeColors = exports.ThemeName = exports.ThemeMode = void 0;
var _icfPlatformid = require("@atg/icf-platformid");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var themeColors = exports.themeColors = ["primary", "alert", "warning", "success", "info", "active", "activeVariant", "gold", "goldVariant", "goldGradient", "goldGradientHover", "textOnDark", "textOnLight", "baseShadow", "baseInvariant", "primaryLight", "primaryDark", "themeBase", "pageBackground", "baseContrast010", "baseContrast015", "baseContrast020", "baseContrast030", "baseContrast040", "baseContrast050", "baseContrast060", "baseContrast070", "baseContrast080", "baseContrast085", "baseContrast090", "baseContrast100", "streamatePrimary", "streamfansPrimary", "kwikyPrimary", "adminproPrimary", "cambuilderPrimary", "creatorPrimary"];
var ThemeMode = exports.ThemeMode = /*#__PURE__*/function (ThemeMode) {
  ThemeMode["dark"] = "dark";
  ThemeMode["light"] = "light";
  return ThemeMode;
}({});
var Direction = exports.Direction = /*#__PURE__*/function (Direction) {
  Direction["rtl"] = "rtl";
  Direction["ltr"] = "ltr";
  return Direction;
}({});
var Language = exports.Language = /*#__PURE__*/function (Language) {
  Language["de"] = "de";
  Language["en"] = "en";
  Language["es"] = "es";
  Language["fr"] = "fr";
  Language["he"] = "he";
  Language["it"] = "it";
  Language["nl"] = "nl";
  Language["no"] = "no";
  Language["pt"] = "pt";
  Language["ro"] = "ro";
  Language["ru"] = "ru";
  Language["sv"] = "sv";
  return Language;
}({}); // internal use only
// https://confluence.atg-corp.com/display/~rickk/Introducing+platformid
var ThemeName = exports.ThemeName = /*#__PURE__*/function (ThemeName) {
  ThemeName["whitelabel"] = "whitelabel";
  ThemeName["performer"] = "performer";
  ThemeName["admin"] = "admin";
  ThemeName["cambuilder"] = "cambuilder";
  ThemeName["streamfans"] = "streamfans";
  ThemeName["kwiky"] = "kwiky";
  return ThemeName;
}({}); // This is currently experimental and subject to change